import { render } from "./NewsfeedDetail.vue?vue&type=template&id=d5834316&scoped=true"
import script from "./NewsfeedDetail.vue?vue&type=script&lang=js"
export * from "./NewsfeedDetail.vue?vue&type=script&lang=js"

import "./NewsfeedDetail.vue?vue&type=style&index=0&id=d5834316&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5834316"]])

export default __exports__